import { processHtmlAttributes } from "../../common/html-attributes/index.js";
static function toJSON() {
  return {
    disabled: this.disabled
  };
}
$ const {
  variant,
  type,
  renderBody,
  class: inputClass,
  ...htmlInput
} = input;
$ input.toJSON = toJSON;
<button ...processHtmlAttributes(htmlInput) onClick("handleClick") onKeydown("handleKeydown") onFocus("handleFocus") onBlur("handleBlur") class=[inputClass, "fake-link", variant === 'standalone' && 'standalone-link'] data-ebayui type=(type || "button")>
  <${renderBody}/>
</button>